import zontaNewsBg from "../assets/buttons/tv_zonta_zontanews.svg";
import universidadeCorporativaBg from "../assets/buttons/tv_zonta_uc.svg";
import aovivoBg from "../assets/buttons/tv_zonta_aovivo.svg";
import institutoJoanirZontaBg from "../assets/buttons/tv_zonta_instituto.svg";
import recrutamentoEselecaoBg from "../assets/buttons/tv_zonta_recrutamento.svg";
import ucBg from "../assets/buttons/tv_zonta_uconline.svg";
import { defineButton } from "./components/DynamicBigButton";
import { UNIVERSIDADE_CORPORATIVA_CATEGORIA_ID } from "./constants";

export const BUTTONS = {
	INSTITUTO_JOANIR_ZONTA: defineButton({
		label: "Instituto Joanir Zonta",
		backgroundUrl: institutoJoanirZontaBg,
		navigateTo: "instituto_joanir_zonta",
	}),
	ZONTA_NEWS: defineButton({
		label: "Zonta News",
		backgroundUrl: zontaNewsBg,
		navigateTo: "condor_news",
	}),
	UNIVERSIDADE_CORPORATIVA: defineButton({
		label: "Universidade Corporativa",
		backgroundUrl: universidadeCorporativaBg,
		navigateTo: `treinamento/${UNIVERSIDADE_CORPORATIVA_CATEGORIA_ID}`,
	}),
	RECRUTAMENTO_E_SELECAO: defineButton({
		label: "Recrutamento e Seleção",
		navigateTo: "recrutamento_e_selecao",
		backgroundUrl: recrutamentoEselecaoBg,
	}),
	AO_VIVO: defineButton({
		label: "Ao vivo",
		backgroundUrl: aovivoBg,
		navigateTo: "aovivo",
	}),
	UC_ONLINE: defineButton({
		label: "UC Online",
		backgroundUrl: ucBg,
		href: "https://universidade.condor.com.br/",
		target: "_blank",
	})
} as const;
